import { VehicleFeatures } from '../components/vdp/vehicle-features.vue';
Vue.component('vehicle-features', VehicleFeatures);